<ng-container *ngIf="booking$ | async as booking">
  <div class="header">
    <h2 class="headline">
      {{
        'usage.report.headline'
          | transloco: { service: booking.cartridgeVariantName }
      }}
    </h2>
    <markant-button
      *ngIf="isOrganizationAdmin$ | async"
      class="widget-button"
      colorScheme="primary"
      variant="clear"
      [routerLink]="['/widget-selection']"
      [fragment]="booking.cartridgeVariantId"
    >
      <markant-icon icon="m_widget-add" slot="icon-leading"></markant-icon>
      {{ 'usage.report.widget.add' | transloco }}
    </markant-button>
  </div>

  <markant-segmented-control-group
    class="view-control"
    colorScheme="secondary"
    [value]="viewMode"
    (valueChange)="onViewModeChange($any($event).detail)"
  >
    <markant-segmented-control
      *ngFor="let viewMode of UsageReportViewMode | keyvalue"
      [icon]="UsageReportViewModeMap[viewMode.value].icon"
      [value]="viewMode.value"
    ></markant-segmented-control>
  </markant-segmented-control-group>

  <div class="content">
    <markant-platform-ui-card class="usage-filter">
      <markant-platform-usage-report-filter
        [servicePackages]="booking.cartridgeServicePackageData ?? []"
        [usageStartedAt]="booking.bookingStartedAt"
        [billingPeriod]="booking.price.billingPeriod"
        (filterChanged)="onUpdateFilter(booking, $event)"
      ></markant-platform-usage-report-filter>
    </markant-platform-ui-card>

    <div class="usage-details">
      <markant-platform-ui-card class="usage-details-total">
        <h6 class="usage-details-total-label">
          {{
            'usage.report.details.total'
              | transloco: { servicePackage: selectedServicePackage?.name }
          }}
          <h4 class="usage-details-total-value">
            {{ (total$ | async) ?? 0 | translocoDecimal }}
          </h4>
        </h6>
      </markant-platform-ui-card>
      <ng-container>
        <markant-platform-ui-card
          *ngIf="viewMode === 'chart'; else table"
          class="usage-details-chart"
        >
          <markant-platform-usage-report-chart
            [filter]="filter"
            [loadFn]="getAggregatedUsages(booking)"
          >
          </markant-platform-usage-report-chart>
        </markant-platform-ui-card>
        <ng-template #table>
          <markant-platform-usage-report-table
            [draft]="tableDraft"
            [filter]="filter"
            [loadFn]="getAggregatedUsages(booking)"
          >
          </markant-platform-usage-report-table>
        </ng-template>
      </ng-container>
    </div>
  </div>
</ng-container>
